/* eslint-disable */
/**
 * @author Vincent Bruijn <vincent-bruijn@g-star.com>
 */
import Mustache from 'mustache';

self.onmessage = function (event) {
  const { template, data, counter } = event.data;
  let html = 'error';

  if (template && data !== null && typeof data === 'object') {
    html = Mustache.render(template, data);
  }
  self.postMessage({ html, counter });
};
